import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  CompanyPageHero,
  CompanyPageShell,
  useCompanyLang
} from "@/components/site/company/CompanyShared";
import {
  CompanyInquiryForm,
  CompanyNextSteps
} from "@/components/site/company/CompanyInquiryForm";
import {
  companyCatalogGroups,
  companyDrugOptions,
  certificatesForCompanyGroup
} from "@/data/company";
import { PageMeta } from "@/components/site/PageMeta";

const ForetagKontakt = () => {
  const { lang, copy } = useCompanyLang();
  const k = copy.kontakt;
  const [searchParams] = useSearchParams();

  const validSlugs = useMemo(() => {
    const slugs = new Set<string>([
      "flera-tjanster",
      ...companyDrugOptions.map((option) => option.slug),
      ...companyCatalogGroups.flatMap((group) =>
        certificatesForCompanyGroup(group.id).map((cert) => cert.slug),
      ),
    ]);
    return slugs;
  }, []);

  const initialServices = useMemo(() => {
    const values = searchParams.getAll("tjanst");
    const single = searchParams.get("tjanst");
    const all = values.length ? values : single ? [single] : [];
    return [...new Set(all.filter((slug) => validSlugs.has(slug)))];
  }, [searchParams, validSlugs]);

  const initialSample = useMemo(() => {
    const prov = searchParams.get("prov");
    if (prov === "saliv" || prov === "urin") return prov;
    return "ej-valt" as const;
  }, [searchParams]);



  return (
    <CompanyPageShell breadcrumbLabel={copy.nav.kontakt}>
      <PageMeta title={k.metaTitle} description={k.metaDescription} titleMaxLength={70} />
      <CompanyPageHero label={k.label} title={k.title}>
        <p>{k.subtitle}</p>
      </CompanyPageHero>

      <section className="pb-20">
        <div className="container-wide grid gap-8 lg:grid-cols-[1.4fr_0.9fr] lg:items-start">
          <CompanyInquiryForm
            key={`${initialServices.join(",")}-${initialSample}`}
            lang={lang}
            initialServices={initialServices}
            initialSample={initialSample}
          />
          <CompanyNextSteps lang={lang} />
        </div>
      </section>
    </CompanyPageShell>
  );
};

export default ForetagKontakt;
